fragment MaterializedEmailSequence on MaterializedEmailSequenceTemplate {
    entity {
        id
    }
    emailSequenceTemplate {
        id
        name
        isShared
        creatorUser {
            id
        }
    }
    materializedEmailSequenceTemplateMessages {
        materializedEmailTemplate {
            subject
            body
            missingFieldsMessage
            plaintextBody
        }
        emailSequenceTemplateMessage {
            emailTemplate {
                id
            }
            sendDelay {
                delayUnit
                delayTimespan
            }
            expectedSendTime
            sendAsReply
        }
    }
}
